import { PerformanceThresholds, DEFAULT_THRESHOLDS } from './OfferPerformanceSettings';

const STORAGE_KEY = 'offerPerformanceThresholds';

export function loadThresholds(): PerformanceThresholds {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      // Validate structure
      if (
        parsed.excellent &&
        parsed.good &&
        parsed.average &&
        typeof parsed.excellent.minAvgRevenue === 'number' &&
        typeof parsed.excellent.minProductsSold === 'number' &&
        typeof parsed.good.minAvgRevenue === 'number' &&
        typeof parsed.good.minProductsSold === 'number' &&
        typeof parsed.average.minAvgRevenue === 'number' &&
        typeof parsed.average.minProductsSold === 'number'
      ) {
        return parsed;
      }
    }
  } catch (error) {
    console.error('Error loading performance thresholds:', error);
  }
  return DEFAULT_THRESHOLDS;
}

export function saveThresholds(thresholds: PerformanceThresholds): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(thresholds));
  } catch (error) {
    console.error('Error saving performance thresholds:', error);
  }
}
